// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ModalCompanyUsersModuleLayout} from 'app_components/modules/modalCompanyUsers'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import CompanyService from 'app_services/admin/company/companyService'
// @end

// @import types
import { IUserListItem } from 'app_types/admin/user/userTypes'
import {ICompanyUsersResponse} from 'app_types/admin/company/companyTypes'
import { IPagination } from 'app_types/pagination/paginationTypes'
import { ICompanyListItem } from 'app_types/admin/company/companyTypes'
// @end

// @ADD Component types
interface IModalCompanyUsersModuleProps {
  open       : boolean
  handleClose: (data:any) => void
  company: ICompanyListItem
}
interface IModalCompanyUsersModuleState {
  firstLoad: boolean
  loading: boolean
  processing: boolean
  errors: Array<any>
  pagination: IPagination,
  users: IUserListItem[]
  usersAvailable: IUserListItem[]
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ModalCompanyUsersModule extends Component<IModalCompanyUsersModuleProps, IModalCompanyUsersModuleState> {

  private companyService: CompanyService
  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IModalCompanyUsersModuleProps) {
    super(props)
    this.state = {
      firstLoad: true,
      loading: true,
      processing: false,
      errors: [],
      pagination: {
        page: 1,
        perPage: 10,
        total: 0,
      },
      users: [],
      usersAvailable: []
    }
    this.companyService = new CompanyService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.fetchCompanyUsers()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  fetchCompanyUsers = async (params?: any) => {

    this.setState({ loading: true })

    const httpParams: any = {
      company: this.props.company._id,
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      searchUsersAvailable: (this.state.firstLoad || params.searchUsersAvailable) ? true : false
    }

    let itemList: ICompanyUsersResponse | null = await this.companyService.companyUsers(httpParams)

    if (itemList?.status_code === 'success') {
      let objectState: any = {
        loading: false,
      }
      if (itemList.company_users?.nPerPage) {
        objectState['users'] = itemList?.company_users?.users ? itemList?.company_users?.users : []
        objectState['pagination'] = {
          total: itemList?.company_users.total_register,
          perPage: itemList?.company_users.nPerPage,
          page: itemList?.company_users.pageNumber,
        }
      }
      if (itemList.users_available) {
        objectState['usersAvailable'] = itemList.users_available?.users ? itemList.users_available?.users : []
        objectState['firstLoad'] = false
      }
      this.setState(objectState)
    } else {
      this.setState({ loading: false })
    }
  }

  onPageChange = async (page: number) => {
    this.fetchCompanyUsers({ page })
  }

  render() {
    return(
      <ModalCompanyUsersModuleLayout
        open={this.props.open}
        handleClose={this.props.handleClose}
        loading={this.state.loading}
        processing={this.state.processing}
        errors={this.state.errors}
        users={this.state.users}
        usersAvailable={this.state.usersAvailable}
        pagination={this.state.pagination}
        company={this.props.company}
        refreshList={this.fetchCompanyUsers}
        onPageChange={this.onPageChange}
      />
    )
  }
}

export default connect(mapStatesToProps)(ModalCompanyUsersModule)
